export default "__VITE_ASSET__Bebpux2p__"